import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';

import {
  getBlocksDefaultMap,
  getBlocksFromMap,
  getBlocksMapInOrder,
} from '../../components/Menu/utils';
import AddMenu from './AddMenu';
import { addMenuItemType, addMenuProps, blockType } from './types';
import {
  filterAddMenuBlocks,
  useAvailableBlocks,
  useHandleKeyDown,
  useMenuItemClick,
  usePopperOptions,
} from './useAddMenuActions';
import { hideAddMenu } from './utils';
// import { Map } from 'yjs';

export const AddMenuContainer: React.FC<addMenuProps> = (props) => {
  const {
    open,
    editorView: view,
    offset,
    placement,
    anchorEl,
    match,
    blocks,
    isMicroLearning,
    isByteContent,
  } = props;
  const menuRef = useRef<HTMLDivElement>(null);
  // This function will be called when user clicks the menuItem
  // and corresponding command will be fired. It will also fire
  // the popoverClose command to remove the '/'.
  const [selectedMenuItemIndex, setSelectedMenuItemIndex] = useState(0);

  useEffect(() => setSelectedMenuItemIndex(0), [match]);

  // If iniside table/tabs/toggleList block only allow certain nodes.
  const addMenuBlocks = filterAddMenuBlocks(view) || blocks;

  const availableBlocks = useAvailableBlocks(addMenuBlocks, match);

  // need a consistency while selecting the new block with selectedMenuItemIndex.
  const blocksInOrderMap = useMemo(
    () => (match ? getBlocksMapInOrder(availableBlocks) : getBlocksDefaultMap(availableBlocks)),
    [availableBlocks, match],
  );

  const onMenuItemClick = useMenuItemClick(view, isMicroLearning!);

  const popperOptions = usePopperOptions(offset);

  const onClose = useCallback(() => {
    hideAddMenu(view);
  }, [view]);

  const blocksInOrderMap_ = new Map<addMenuItemType, blockType[]>();
  // If you need a Yjs Map, use: new Y.Map(); Otherwise, use the built-in Map as above.
  blocksInOrderMap_.set(
    addMenuItemType.media,
    blocksInOrderMap
      .get(addMenuItemType.media)
      ?.filter((block) => block.name == 'video' || block.name == 'image') || [],
  );

  blocksInOrderMap_.set(addMenuItemType.embeds, blocksInOrderMap.get(addMenuItemType.embeds) || []);

  if (isByteContent) {
    blocksInOrderMap_.clear();
    blocksInOrderMap_.set(
      addMenuItemType.media,
      blocksInOrderMap.get(addMenuItemType.media)?.filter((block) => block.name == 'video') || [],
    );
  }

  useHandleKeyDown(
    open,
    selectedMenuItemIndex,
    setSelectedMenuItemIndex,
    getBlocksFromMap(isMicroLearning ? blocksInOrderMap_ : blocksInOrderMap),
    onMenuItemClick,
    view,
    menuRef,
  );

  return (
    <AddMenu
      anchorEl={anchorEl}
      blocksMap={isMicroLearning ? blocksInOrderMap_ : blocksInOrderMap}
      isMicroLearning={isMicroLearning}
      menuRef={menuRef}
      open={open && !!availableBlocks.length}
      placement={placement}
      popperOptions={popperOptions}
      selectedMenuItemIndex={selectedMenuItemIndex}
      onClick={onMenuItemClick}
      onClose={onClose}
    />
  );
};
